import React, { memo } from 'react';
import { useLocation } from 'react-router-dom';
import JsonSchema from '../../../components/JsonSchema';
import getRoute from '../../../utils/getRoute';
import LocalBusinessSchema from './LocalBusinessSchema';
import ProductSchema from './ProductSchema';

const Schema = memo(({ data, links, reviewAggregates, reviews }) => {
  const { pathname } = useLocation();
  const route = getRoute(pathname);
  const isFind = route === 'find';

  const faqSchema = faqs => {
    let schema;
    if (faqs && !!faqs.length) {
      schema = {
        '@context': 'https://schema.org',
        '@type': 'FAQPage',
        mainEntity: [],
      };
      schema.mainEntity = faqs.reduce((sum, faq) => {
        if (faq.q && faq.a)
          return sum.concat({
            '@type': 'Question',
            name: faq.q,
            acceptedAnswer: {
              '@type': 'Answer',
              text: faq.a,
            },
          });
        return sum;
      }, []);
    }
    return schema;
  };

  if (data && !!data.length && links && isFind) {
    const { faq, meta } = links || {};
    const FaqSchema = faqSchema(faq);

    return (
      <>
        {FaqSchema && JsonSchema(FaqSchema)}
        {data.map(({ attributes }, key) => (
          <LocalBusinessSchema key={key.toString()} data={attributes} />
        ))}
        <ProductSchema
          reviewAggregates={reviewAggregates}
          meta={meta}
          reviews={reviews}
        />
      </>
    );
  }
  return '';
});

export default Schema;
